import React from 'react';
//import { translate, Trans } from 'react-i18next';
import { translate} from 'react-i18next';

import { I18n, Trans } from 'react-i18next';

export class Header extends React.Component {
  render() {
  return (
    <I18n ns="translations">
        {
          (t, { i18n }) => (
            <header id="header-section">
			    <div className="container">
			      <div className="row">
			        <div className="col-md-6 col-sm-6 col-xs-12 center-pad">
			          <h1 id="profile-text">{t('title')}</h1>
			          <ul id="header-text">
			            <li>{t('line1')}</li>
			            <li>{t('line2')}</li>
			            <li>{t('line3')}</li>
			          </ul>
			          <ul id="header-links">
			            <li><a href="https://play.google.com/store/apps/details?id=fr.hapiwine.application" target="_blank"><img src="../../images/header_google_play.png"/></a> </li>
			            <li><a href="https://itunes.apple.com/fr/app/hapiwine/id1068486486?mt=8" target="_blank"><img src="../../images/header_app_store.png"/></a> </li>
			          </ul>
			        </div>
			      </div>      
			    </div>
			  </header>
		    )
         }
      </I18n>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Header/Header.js